import '@babel/polyfill';
import 'whatwg-fetch';
// eslint-disable-next-line
__webpack_public_path__ = window.env.WEBPACK_PUBLIC_PATH;
